import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-public',
  template: `
<footer class="container-fluid bg-dark p-4 text-white small">
  <div class="row">
    <ul class="nav container w-100 flex-sm-nowrap justify-content-center justify-content-sm-end text-center">
      <li *ngFor="let link of linkList" class="nav-item p-2 col-12 col-sm-auto">
        <a class="text-white" [routerLink]="[ link.href ]">{{ link.label }}</a>
      </li>
    </ul>
  </div>
</footer>
`
})
export class FooterPublicComponent implements OnInit {
  @Input() PrivacyPolicyLabel: string;
  @Input() FaqLabel: string;
  @Input() ContactUsLabel: string;

  linkList: Array<{ label: string; href: string }>;

  ngOnInit(): void {
    this.linkList = [
      { label: this.PrivacyPolicyLabel, href: '/privacy' },
      { label: this.FaqLabel, href: '/faqs' },
      { label: this.ContactUsLabel, href: '/contact' }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/global/footer-public.component.ts